import React, { Component } from "react";
import { templateDisplayName } from "./searchModes";

const plural = (count, one, many) => `${count} ${count === 1 ? one : many}`;

// A question with no answer, told kindly: where the server looked (its own counts and the records' own names) and a
// new search made of the user's own words, editable before it runs. It never says that something does not exist.
export default class RagMissCard extends Component {
  constructor(props) {
    super(props);
    this.state = { search: (props.explanation && props.explanation.suggestedSearch) || "" };
  }

  componentDidUpdate(previous) {
    const now = this.props.explanation && this.props.explanation.suggestedSearch;
    const before = previous.explanation && previous.explanation.suggestedSearch;
    if (now !== before) this.setState({ search: now || "" });
  }

  submit = (event) => {
    event.preventDefault();
    const text = this.state.search.trim();
    if (text && this.props.onSearch) this.props.onSearch(text);
  };

  render() {
    const { explanation, getDocument, onView, disabled } = this.props;
    if (!explanation || typeof explanation !== "object") return null;
    const count = (value) => (Number.isInteger(value) && value > 0 ? value : 0);
    const inResults = count(explanation.recordsInResults);
    const read = count(explanation.recordsRead);
    const passages = count(explanation.passagesChecked);
    const kinds = (Array.isArray(explanation.kindsRead) ? explanation.kindsRead : [])
      .filter((kind) => kind && typeof kind.name === "string" && kind.name.trim());
    const related = (Array.isArray(explanation.relatedNotRead) ? explanation.relatedNotRead : [])
      .filter((record) => record && Number.isInteger(record.templateId) && Number.isInteger(record.fileId))
      .slice(0, 3);
    const unconfirmed = explanation.reason === "REFUSED_BY_RULE" && explanation.rule === "FAIL_CLOSED";
    const notFoundByName = explanation.reason === "REFUSED_BY_RULE" && explanation.rule === "DOCUMENT_NOT_FOUND";
    const text = this.state.search.trim();
    // Said the way an assistant would say it, in a few plain sentences, from the server's own counts and records only.
    const kindNames = [...kinds]
      .sort((x, y) => count(y.count) - count(x.count))
      .slice(0, 2)
      .map((kind) => templateDisplayName(kind.name));
    const looked = read > 0
      ? `I went through ${inResults > read ? `${read} of the ${inResults} records in your results` : plural(read, "record", "records")}` +
        (kindNames.length ? ` (${kindNames.join(" and ")})` : "") +
        (passages > 0 ? ` and read ${plural(passages, "passage", "passages")}.` : ".")
      : inResults > 0
        ? `Your results hold ${plural(inResults, "record", "records")}.`
        : "";
    const opening = unconfirmed
      ? "The passages below mention this, but none of them says it clearly enough for me to give you an answer."
      : notFoundByName
        ? "I couldn't find that record among these results."
        : "I couldn't find this in the records I checked.";
    const relatedLinks = related.map((record, index) => {
      const resolved = getDocument ? getDocument(record) : { title: record.fileName, document: null };
      const title = (record.fileName && record.fileName.trim()) || resolved.title || "Document";
      const separator = index === 0 ? "" : index === related.length - 1 ? " or " : ", ";
      return (
        <React.Fragment key={`${record.templateId}:${record.fileId}`}>
          {separator}
          {resolved.document && onView ? (
            <button type="button" className="chat-search-citation-button" onClick={() => onView(resolved.document)}>
              {title}
            </button>
          ) : (
            title
          )}
        </React.Fragment>
      );
    });
    return (
      <section className="chat-search-miss-card" aria-label="What I looked at">
        <p className="chat-search-miss-where">
          {opening}
          {looked ? ` ${looked}` : ""}
          {!unconfirmed && !notFoundByName ? " It may still be in a record these results didn't include." : ""}
        </p>
        {related.length > 0 && (
          <p className="chat-search-miss-related">
            I didn't read {relatedLinks} for this question. You can open {related.length === 1 ? "it" : "them"}, or ask about one by name.
          </p>
        )}
        {explanation.suggestedSearch && this.props.onSearch && (
          <form className="chat-search-miss-try" onSubmit={this.submit}>
            <label htmlFor="chatSearchMissInput">Or try a new search with your words (you can change them):</label>
            <div className="chat-search-miss-row">
              <input
                id="chatSearchMissInput"
                type="text"
                value={this.state.search}
                maxLength={500}
                onChange={(event) => this.setState({ search: event.target.value })}
                disabled={disabled}
              />
              <button type="submit" className="chat-search-ai-action" disabled={disabled || !text}>
                Search for: {text || "…"}
              </button>
            </div>
          </form>
        )}
      </section>
    );
  }
}
